<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
import Fingerprint2 from "fingerprintjs2";
import Vue from "vue";
export default {
  name: "app",
  data() {
    return {
      intervalId: null, // 存储定时器 ID
      checkInterval: 60 * 1000, // 检查间隔（60秒）
    };
  },
  mounted() {
    console.log('更新了');
    Fingerprint2.get((components) => {
      // 参数只有回调函数时，默认浏览器指纹依据所有配置信息进行生成
      const values = components.map((component) => component.value); // 配置的值的数组
      const murmur = Fingerprint2.x64hash128(values.join(""), 31); // 生成浏览器指纹
      localStorage.setItem("browserId", murmur); // 存储浏览器指纹，在项目中用于校验用户身份和埋点
      Vue.prototype.$browserId = murmur; // 存储浏览器指纹，在项目中用于校验用户身份和埋点
    });
    this.startTokenCheck();
  },
  beforeDestroy() {
    this.stopTokenCheck();
  },
  methods: {
    // 启动 Token 检查
    startTokenCheck() {
      this.checkTokenExpiry(); // 立即检查一次
      this.intervalId = setInterval(this.checkTokenExpiry, this.checkInterval);
      // 监听当前网页是否处于活动状态 && 获得焦点的时候
      document.addEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
      window.addEventListener("focus", this.handleVisibilityChange);
    },
    // 停止 Token 检查
    stopTokenCheck() {
      if (this.intervalId) clearInterval(this.intervalId);
      document.removeEventListener(
        "visibilitychange",
        this.handleVisibilityChange
      );
      window.removeEventListener("focus", this.handleVisibilityChange);
    },
    // 检查 Token 是否过期
    checkTokenExpiry() {
      const token = this.$cookie.get("TOKEN");
      const query = this.$route.query;
      const redirect_url = query?.redirect_url;
      const app_name = query?.app_name;
      const noCheckIn = ["/", "/sso"];
      if (!token && !noCheckIn.includes(this.$route.path))
        return this.$router.replace({
          path: "/",
          query: { app_name, redirect_url },
        });
    },
    handleVisibilityChange() {
      if (document.visibilityState === "visible") {
        this.checkTokenExpiry(); // 页面重新可见时立即检查
      }
    },
  },
};
</script>
 
<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
/* 禁止用户选中文本 */
* {
  -webkit-user-select: none; /* webkit浏览器 */
  -khtml-user-select: none; /* 早期浏览器 */
  -moz-user-select: none; /* 火狐 */
  -ms-user-select: none; /* IE10 */
  user-select: none; /* 禁止用户选中文本 */
}
/* 允许用户输入文本 */
input,
textarea {
  -webkit-user-select: text; /* webkit浏览器 */
  -khtml-user-select: text; /* 早期浏览器 */
  -moz-user-select: text; /* 火狐 */
  -ms-user-select: text; /* IE10 */
  user-select: text; /* 允许用户输入文本 */
}

h1,
h2,
h3,
h4,
h5,
h6,
p {
  margin: 0;
}
</style>
